const inputsAuditActionsSystem = {
  fio: {
    key: "fio",
    label: "Пользователь",
    type: "text",
    disabled: false,
    required: false,
  },
  objectId: {
    key: "objectId",
    label: "Объект учета",
    type: "selectWithSearch",
    disabled: false,
    required: false,
    options: [{ value: 0, label: "Все", key: "objectId" }],
  },
  logDocNum: {
    key: "logDocNum",
    label: "Номер объекта",
    type: "text",
    disabled: false,
    required: false,
  },
  startDate: {
    key: "startDate",
    label: "Дата события с",
    type: "date",
    disabled: false,
    required: false,
  },
  endDate: {
    key: "endDate",
    label: "Дата события по",
    type: "date",
    disabled: false,
    required: false,
  },
};
export const serInputsAuditActionsSystem = (type, props) => {
  switch (type) {
    case "firstInit": {
      if ((inputsAuditActionsSystem.objectId.options.length = 1)) {
        inputsAuditActionsSystem.objectId.options.push(...props);
      }
    }
  }
};
export const getInputsAuditActionsSystem = () => inputsAuditActionsSystem;
